"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var _bindCate = _interopRequireDefault(require("./bindCate.vue"));
var _uploadFile = _interopRequireDefault(require("@/components/Upload/uploadFile.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    BindCate: _bindCate.default,
    UploadFile: _uploadFile.default
  },
  data: function data() {
    return {
      loading: false,
      constants: this.$constants,
      treeList: [],
      listPram: {}
    };
  },
  mounted: function mounted() {
    this.handlerGetTreeList();
  },
  methods: {
    onchangeIsShow: function onchangeIsShow(row) {
      var _this = this;
      categoryApi.changeJdCateState({
        cateId: row.id,
        status: row.status
      }).then(function () {
        _this.$message.success('修改成功');
        _this.handlerGetTreeList();
      }).catch(function () {
        _this.handlerGetTreeList();
      });
    },
    handlerGetList: function handlerGetList() {
      this.handlerGetTreeList(1);
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this2 = this;
      var isSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.loading = true;
      categoryApi.jdCateLists(_objectSpread({}, this.listPram)).then(function (res) {
        _this2.treeList = _this2.handleAddArrt(res);
        setTimeout(function () {
          _this2.loading = false;
        }, isSearch == 0 ? 1000 : 300);
      }).catch(function () {
        _this2.loading = false;
      });
    },
    handleAddArrt: function handleAddArrt(treeData) {
      var _result = selfUtil.addTreeListLabel(treeData);
      return _result;
    },
    openBindCate: function openBindCate(row) {
      var _this$$refs$BindCateR;
      (_this$$refs$BindCateR = this.$refs['BindCateRef']) === null || _this$$refs$BindCateR === void 0 ? void 0 : _this$$refs$BindCateR.openInit(row);
    },
    syncCate: function syncCate() {
      var _this3 = this;
      this.$confirm('是否确定同步分类', '提示').then(function (result) {
        categoryApi.syncJdCate(_this3.listPram).then(function (data) {
          _this3.$message.success(data || '操作成功！');
          _this3.handlerGetListData(_this3.listPram);
        });
      });
    },
    requestUpload: function requestUpload() {},
    beforeUpload: function beforeUpload(file) {
      var _this4 = this;
      var formData = new FormData();
      formData.append('file', file);
      var loading = this.$loading({
        lock: true,
        text: 'Loading'
      });
      categoryApi.importCate(formData).then(function (res) {
        _this4.$message.success('导入成功');
        _this4.handlerGetListData(_this4.listPram);
        loading.close();
      }).catch(function (err) {
        loading.close();
        _this4.$message.error(err.message);
      });
    }
  }
};